import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppShell } from "@/components/AppShell";
import { AuthPage } from "@/components/AuthPage";
import { Dashboard } from "@/components/Dashboard";
import { ProjectList } from "@/components/ProjectList";
import { ProjectWorkspace } from "@/components/ProjectWorkspace";
import { Settings } from "@/components/Settings";
import { Repository } from "@/components/Repository";
import { Pipelines } from "@/components/Pipelines";
import { Review } from "@/components/Review";
import { KnowledgeGraph } from "@/components/KnowledgeGraph";
import { Integrations } from "@/components/Integrations";
import { Observability } from "@/components/Observability";
import { ProjectDetail } from "@/components/ProjectDetail";
import { Agents } from "@/components/Agents";
import { TemplateManager } from "@/components/TemplateManager";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter basename={'/learning-apps/kadal-pipeline'}>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/projects/:projectId/detail" element={<ProjectDetail />} />
            <Route path="/projects/:projectId" element={<ProjectWorkspace />} />
            <Route path="/repository" element={<Repository />} />
            <Route path="/orchestrations" element={<Pipelines />} />
            <Route path="/pipelines" element={<Pipelines />} />
            <Route path="/review" element={<Review />} />
            <Route path="/graph" element={<KnowledgeGraph />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/observability" element={<Observability />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/templates" element={<TemplateManager />} />
          </Route>
        </Routes>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
